import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.0194 0.00219727L15.5094 7.99035L23.4976 11.4804L15.5094 14.9704L12.0194 22.9585L8.52942 14.9704L0.54126 11.4804L8.52942 7.99035L12.0194 0.00219727ZM21.3247 3.32469L19.7559 4.10559L21.3247 4.8865L22.1056 6.45532L22.8865 4.8865L24.4553 4.10559L22.8865 3.32469L22.1056 1.75586L21.3247 3.32469ZM19.3353 14.7559L20.6346 17.3661L23.2449 18.6654L20.6346 19.9647L19.3353 22.575L18.0361 19.9647L15.4258 18.6654L18.0361 17.3661L19.3353 14.7559Z"}}]};

const Filter3Filled = Vue.extend<IconProps>({
  name: 'Filter3FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'filter-3-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Filter3Filled;
